import commonUtil from '../../common/commonUtil';
import './../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css';
import './../../resources_membership_hotel/css/esthetic/bookingConfirm.css';

export const ImportedInfoComf = (props) => {
    const { data, cornerBunKbn, isWideTablet } = props;
    const foodTime = data?.[0]?.foodTimeList?.[0];
    return (
        <>
            {foodTime ?
                <>
                    {cornerBunKbn == "1" &&
                        <div className='reserveInfoContentBlock'>
                                {foodTime.adultCnt && foodTime.adultCnt > 0 ?
                                    <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                        <div className='membership_reserve_cancel_subtitle2'>ご利用人数</div>
                                        <div className='membership_reserve_cancel_info2'>大人</div>
                                        <div className='membership_reserve_cancel_info3'>{foodTime.adultCnt}人</div>
                                    </div>
                                    : null}
                                {foodTime.childCnt && foodTime.childCnt > 0 ?
                                    <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                        <div className='membership_reserve_cancel_subtitle2'></div>
                                        <div className='membership_reserve_cancel_info2'>小学生</div>
                                        <div className='membership_reserve_cancel_info3'>{foodTime.childCnt}人</div>
                                    </div>
                                    : null}
                                {foodTime.preschoolerCnt && foodTime.preschoolerCnt > 0 ?
                                    <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                        <div className='membership_reserve_cancel_subtitle2'></div>
                                        <div className='membership_reserve_cancel_info2'>幼児（3歳〜5歳）</div>
                                        <div className='membership_reserve_cancel_info3'>{foodTime.preschoolerCnt}人</div>
                                    </div>
                                    : null}
                                {foodTime.babyCnt && foodTime.babyCnt > 0 ?
                                    <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                        <div className='membership_reserve_cancel_subtitle2'></div>
                                        <div className='membership_reserve_cancel_info2'>乳児（0歳〜2歳）</div>
                                        <div className='membership_reserve_cancel_info3'>{foodTime.babyCnt}人</div>
                                    </div>
                                    : null}
                        </div>
                    }
                    {foodTime.startTime &&
                        <div className='reserveInfoContentBlock importedFlex'>
                            <div className='membership_reserve_cancel_subtitle2'>時間</div>
                            <div className='membership_reserve_cancel_info_block'>{foodTime.startTime ? commonUtil.getTimeStr(foodTime.startTime, "hh:mm").replace(/^0+/, '') : ""}</div>
                        </div>
                    }
                    <div className='reserveInfoContentNonBorder'>
                            {foodTime.courseList.map((course, index) => (
                                <div className={'membership_reserve_cancel_wid' + (index != foodTime.courseList.length - 1 ? " str_padding" : "")}>
                                    {cornerBunKbn == "1" ?
                                        <>
                                        <div className='membership_reserve_cancel_subtitle2'>{index == 0 ? "コース" : ""}</div>
                                            <div className='membership_reserve_cancel_info2'>{course.foodCourseName}</div>
                                            <div className='membership_reserve_cancel_info3'>{course.targetCnt}人</div>
                                        </>
                                        :
                                        <>
                                            <div>{course.foodCourseName}</div>
                                        </>
                                    }
                                </div>
                            ))}
                    </div>
                </>
                :
                null
            }
        </>
    );
};